import React, { useEffect, useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RegionSkeleton from "./region-skeleton";

const WebRegionToggle = ({
  dubaiUrl = "https://www.99gift.ae/",
  indiaUrl = "https://www.99gift.in/",
  loading = false,
}) => {
  // Current website ke domain ke according region detect hoga
  const getCurrentRegion = () => {
    if (typeof window === "undefined") {
      return "INDIA";
    }

    return window.location.hostname.endsWith("99gift.ae")
      ? "UAE"
      : "INDIA";
  };

  const [region, setRegion] = useState(getCurrentRegion);

  // Browser Back / Forward ke case ko handle karega
  useEffect(() => {
    const handlePageShow = () => {
      setRegion(getCurrentRegion());
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const handleRegionChange = (event) => {
    const selectedRegion = event.target.value;

    setRegion(selectedRegion);

    const url =
      selectedRegion === "UAE"
        ? dubaiUrl
        : indiaUrl;

    window.location.href = url;
  };

  if (loading) {
    return <RegionSkeleton />;
  }

  return (
    <Box>
      <Select
        value={region}
        onChange={handleRegionChange}
        size="small"
        displayEmpty
        // IconComponent={() => null}
        renderValue={(selected) => {
          const isUAE = selected === "UAE";

          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "fit-content",
              }}
            >
              {/* Flag */}
              <Box
                component="img"
                src={
                  isUAE
                    ? "https://flagcdn.com/w40/ae.png"
                    : "https://flagcdn.com/w40/in.png"
                }
                alt={isUAE ? "UAE" : "India"}
                sx={{
                  width: 35,
                  height: 23,
                  objectFit: "cover",
                  borderRadius: "2px",
                  display: "block",
                  flexShrink: 0,
                  color: "#002865",
                }}
              />

              {/* Country */}
              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 400,
                  color: "#2B3445",
                  fontFamily: "Be Vietnam Pro",
                  lineHeight: 1.5,
                  whiteSpace: "nowrap",
                }}
              >
                {isUAE ? "UAE" : "India"}
              </Typography>

             

              {/* Arrow */}
<Box
  component="span"
  sx={{
    fontSize: "25px",
    color: "#002865",
    lineHeight: 1,
    flexShrink: 0,
  }}
>
  
</Box>
            </Box>
          );
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              borderRadius: "10px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
            },
          },
        }}
        sx={{
          minWidth: "fit-content",
          height: 60,

          backgroundColor: "white.main",

          border: 1,
          borderColor: "lightSecondary.main",

          borderRadius: {
            sm: 1,
            xl: 6,
          },

          px: {
            sm: 1,
            lg: 2,
          },

          py: "2px",

          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },

          "&:hover": {
            boxShadow: 1,
          },

          // Same type of spacing as HandleUserLogin
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            padding: "0 !important",
            minHeight: "auto !important",
          },
        }}
      >
        {/* UAE */}
        <MenuItem value="UAE">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              width: "100%",
            }}
          >
            <Box
              component="img"
              src="https://flagcdn.com/w40/ae.png"
              alt="UAE"
              sx={{
                width: 32,
                height: 21,
                objectFit: "cover",
                borderRadius: "2px",
                display: "block",
              }}
            />

            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 500,
                color: "#2B3445",
                fontFamily: "Be Vietnam Pro",
              }}
            >
              Uae
            </Typography>
          </Box>
        </MenuItem>

        {/* India */}
        <MenuItem value="INDIA">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              width: "100%",
            }}
          >
            <Box
              component="img"
              src="https://flagcdn.com/w40/in.png"
              alt="India"
              sx={{
                width: 32,
                height: 21,
                objectFit: "cover",
                borderRadius: "2px",
                display: "block",
              }}
            />

            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 500,
                color: "#2B3445",
                fontFamily: "Be Vietnam Pro",
              }}
            >
              India
            </Typography>
          </Box>
        </MenuItem>
      </Select>
    </Box>
  );
};

export default WebRegionToggle;